import REPORT_TYPE from '../common/reportTypes';
import type { ReportType } from '../common/reportTypes';

export const RECONNECT_REPORT_FLAGS: Partial<Record<ReportType, string>> = {
  [REPORT_TYPE.SALES_OVERVIEW]: 'CD-2850-sales-overview-reconnect',
  [REPORT_TYPE.PRODUCT_SALES]: 'SFT-903-product-sales-reconnect',
  [REPORT_TYPE.SERVICE_SALES]: 'SFT-972-service-sales-reconnect',
};
